/*!
 * Fidget Critter fractal puzzle engine (prototype)
 * Core generator (classes Tile..CircleFractalJigsaw) copied verbatim from
 * Fractalpuzzlejs by proceduraljigsaw - https://github.com/proceduraljigsaw/Fractalpuzzlejs
 * (commit c37d7ce, 2021-11-07). MIT License, Copyright (c) 2021 proceduraljigsaw.
 * Upstream HTML/helpers are themselves partly based on https://github.com/Draradech/jigsaw (CC0).
 * Fidget Critter additions (FCFractal wrapper, round mask, presets, exports): same MIT terms.
 * Full license text: see LICENSE next to this file / in the page footer.
 */
var FCFractal = (function () {
  "use strict";
  // ---- deterministic RNG exactly as upstream (sin-based, global seed) ----
  var seed = 1;
  var customborder = {};
  function random() { var x = Math.sin(seed) * 10000; seed += 1; return x - Math.floor(x); }
  function uniform(min, max) { var r = random(); return min + r * (max - min); }
  function rbool() { return random() > 0.5; }
  function $(id) { return document.getElementById(id); }
  function plotpath() { throw new Error("custom SVG borders are not used in this prototype"); }
  function createframe() { throw new Error("unused"); }

      class Tile {
         constructor(x, y) {
            this._x = x;
            this._y = y;
            this.haspossibleconnections = true;
         }
         get hasconnections() {
            return this.haspossibleconnections;
         }
         set hasconnections(val) {
            this.haspossibleconnections = val;
         }
         get x() {
            return this._x;
         }
         get y() {
            return this._y;
         }
         eq(p) {
            return (this.x == p.x && this.y == p.y);
         }
      }

      class Cell {
         constructor(x, y) {
            this._x = x;
            this._y = y;
         }
         get x() {
            return this._x;
         }
         get y() {
            return this._y;
         }
         eq(c) {
            return (this.x == c.x && this.y == c.y);
         }
      }

      class DiagonalConnection {
         constructor(p1, p2, p2_taken) {
            this._p1 = p1;
            this._p2 = p2;
            this._p2_taken = p2_taken;
            this._slope = (p2.y - p1.y) / (p2.x - p1.x);
            var ccx = Math.min(p2.x, p1.x);
            var ccy = Math.min(p2.y, p1.y);
            this._cell = new Cell(ccx, ccy);
            if (this._slope > 0) {
               if (p2.y > p1.y) {
                  this._quad = 3;
               } else {
                  this._quad = 1;
               }
            } else {
               if (p2.y > p1.y) {
                  this._quad = 2;
               } else {
                  this._quad = 0;
               }
            }
         }
         eq(other) {
            return (this === other) || (this.cell.x == other.cell.x && this.cell.y == other.cell.y && this.slope == other.slope && this.p2_taken == other.p2_taken)
         }
         get slope() {
            return this._slope;
         }
         get quad() {
            return this._quad;
         }
         get p1() {
            return this._p1;
         }
         get p2() {
            return this._p2;
         }
         get cell() {
            return this._cell;
         }

         get p2_taken() {
            return this._p2_taken
         }
         static FromPointAndQuad(p1, quadrant, p2_taken) {
            var p2;
            switch (quadrant) {
               case 0:
                  p2 = new Tile(p1.x + 1, p1.y - 1);
                  break;
               case 1:
                  p2 = new Tile(p1.x - 1, p1.y - 1);
                  break;
               case 2:
                  p2 = new Tile(p1.x - 1, p1.y + 1);
                  break;
               case 3:
                  p2 = new Tile(p1.x + 1, p1.y + 1);
                  break;
            }
            return new DiagonalConnection(p1, p2, p2_taken);
         }
      }


      class CellGrid {
         constructor(nrow, ncol) {
            this.nrow = nrow;
            this.ncol = ncol;
            this.visited = new Array(this.ncol * this.nrow).fill(false);
            this.cellmap = new Array((this.ncol - 1) * (this.nrow - 1)).fill(false);
            this._nunvisited = this.ncol * this.nrow;
         }

         randomemptytile() {
            var emptytiles = this.visited.reduce(function (acc, curr, index) {
               if (!curr) {
                  acc.push(index);
               }
               return acc;
            }, []);

            var index = emptytiles[Math.floor(uniform(0, emptytiles.length))];
            var y = Math.floor(index / this.nrow);
            var x = index % this.nrow;
            return new Tile(x, y);
         }

         reset() {
            this.visited.fill(false);
            this.cellmap.fill(false);
            this._nunvisited = this.ncol * this.nrow;
         }
         istilevalid(v) {
            return (v.x >= 0 && v.x < this.nrow && v.y >= 0 && v.y < this.ncol);
         }

         istilevisited(v) {
            return this.visited[v.y * this.nrow + v.x];
         }
         iscellempty(c) {
            return !this.cellmap[c.y * this.nrow + c.x];
         }
         visittile(v) {
            if (!this.visited[v.y * this.nrow + v.x]) {
               this.visited[v.y * this.nrow + v.x] = true;
               this._nunvisited--;
            }
         }
         occupycell(c) {
            if (!this.cellmap[c.y * this.nrow + c.x]) {
               this.cellmap[c.y * this.nrow + c.x] = true;
            }
         }
         liberatecell(c) {
            this.cellmap[c.y * this.nrow + c.x] = false;
         }

         get nunvisited() {
            return this._nunvisited;
         }

         get notvisited() {
            return this._notvisited;
         }

      }

      class Arc {
         constructor(gcp, rad, offs, quad, sign) {
            this._cp = new Tile(gcp.x * 2 * rad + rad + offs, gcp.y * 2 * rad + rad + offs);
            this._quad = quad;
            this._rad = rad;
            this._sign = sign
            var pa;
            var pb;
            switch (quad) {
               case 0:
                  pa = new Tile(this._cp.x + rad, this._cp.y);
                  pb = new Tile(this._cp.x, this._cp.y - rad);
                  break;
               case 1:
                  pa = new Tile(this._cp.x, this._cp.y - rad);
                  pb = new Tile(this._cp.x - rad, this._cp.y);
                  break;
               case 2:
                  pa = new Tile(this._cp.x - rad, this._cp.y);
                  pb = new Tile(this._cp.x, this._cp.y + rad);
                  break;
               case 3:
                  pa = new Tile(this._cp.x, this._cp.y + rad);
                  pb = new Tile(this._cp.x + rad, this._cp.y);
                  break;
            }
            if (this.sign == 0) {
               this._sp = pa;
               this._ep = pb;
            } else {
               this._sp = pb;
               this._ep = pa;
            }
         }
         svg(arcshape) {
            const tan225 = 0.4142135623730950488016887242097;
            var hlen = this._rad * tan225;
            switch (arcshape) {
               case 0: //circle arc
                  return "A " + this._rad + " " + this._rad + " 0 0," + this.sign + " " + this.ep.x + " " + this.ep.y + " ";
                  break;
               case 1: //square
                  return "L " + this.ep.x + " " + this.ep.y + " ";
                  break;
               case 2: //octagon
                  var quad = this._quad;
                  var sp = this.sp;
                  var ep = this.ep;
                  if (this._sign == 1) {
                     sp = this.ep;
                     ep = this.sp;
                  }
                  switch (quad) {
                     case 0:
                        var mp1 = [sp.x, sp.y - hlen];
                        var mp2 = [ep.x + hlen, ep.y];
                        break;
                     case 1:
                        var mp1 = [sp.x - hlen, sp.y];
                        var mp2 = [ep.x, ep.y - hlen];
                        break;
                     case 2:
                        var mp1 = [sp.x, sp.y + hlen];
                        var mp2 = [ep.x - hlen, ep.y];
                        break;
                     case 3:
                        var mp1 = [sp.x + hlen, sp.y];
                        var mp2 = [ep.x, ep.y + hlen];
                        break;
                  }
                  if (this._sign == 1) {
                     return "L " + mp2[0] + " " + mp2[1] + " L " + mp1[0] + " " + mp1[1] + " L " + this.ep.x + " " + this.ep.y + " ";
                  } else {
                     return "L " + mp1[0] + " " + mp1[1] + " L " + mp2[0] + " " + mp2[1] + " L " + this.ep.x + " " + this.ep.y + " ";
                  }
                  break;
            }
         }
         eq(a) {
            return (this.quad == a.quad && this.cp.eq(a.cp));
         }
         get cp() {
            return this._cp;
         }
         get sign() {
            return this._sign;
         }
         get sp() {
            return this._sp;
         }
         get ep() {
            return this._ep;
         }
         get quad() {
            return this._quad;
         }
      }
      class CircleFractalJigsaw {
         constructor(ncols, nrows, minpiecelen, maxpiecelen, border, crad) {
            let Array2D = (row, col) => [...Array(row)].map(x => Array(col).fill(0));

            if (border.paths) {
               ncols = Math.ceil(border.width / (2 * crad)) + 1;
               nrows = Math.ceil(border.height / (2 * crad)) + 1;
            }
            this.ncols = ncols;
            this.nrows = nrows;
            this.maskgrid = Array2D(nrows, ncols);
            this.grid = new CellGrid(ncols, nrows)
            if (border.paths) {
               this.fillmask(border.paths, crad, parseFloat($("frame").value));
               for (var i = 0; i < nrows; i++) {
                  for (var j = 0; j < ncols; j++) {
                     if (this.maskgrid[i][j]) {
                        this.grid.visittile({ x: j, y: i });
                     }
                  }
               }
            }
            this.pieces = [];
            this.maxpiecelen = maxpiecelen;
            this.minpiecelen = minpiecelen;

         }

         fillmask(paths, crad, frame) {
            const crosslookup = [[-1, 0], [1, 0], [0, 1], [0, -1]];
            var dia = 2 * crad;
            var allpts = []
            var minx, miny, maxx, maxy
            for (let p of paths) {
               var pts = plotpath(p, dia);
               pts.forEach((pt) => {
                  allpts.push(pt);
                  if (isNaN(minx) || pt.x < minx) minx = pt.x;
                  if (isNaN(miny) || pt.y < miny) miny = pt.y;
                  if (isNaN(maxx) || pt.x > maxx) maxx = pt.x;
                  if (isNaN(maxy) || pt.y > maxy) maxy = pt.y;
               });

            }
            // console.log("V", minx, maxx, miny, maxy);
            allpts.forEach((p) => {

               this.maskgrid[p.y][p.x] = 1;

            });

            var regnum = 3;

            var grown;
            do {
               var outside = true;
               grown = false;
               for (var i = -1; i < this.nrows + 1; i++) {
                  for (var j = -1; j < this.ncols + 1; j++) {
                     if (i < 0 || j < 0 || i > this.nrows - 1 || j > this.ncols - 1 || (this.maskgrid[i][j] > 1 && this.maskgrid[i][j] < regnum)) {
                        var togrow = [{ r: i, c: j }];
                        do {
                           var p = togrow.pop();
                           crosslookup.forEach((c) => {
                              var ii = p.r + c[0];
                              var jj = p.c + c[1];
                              if (ii >= 0 && jj >= 0 && ii < this.nrows && jj < this.ncols) {

                                 if (!this.maskgrid[ii][jj]) {
                                    togrow.push({ r: ii, c: jj });
                                 }
                                 if (this.maskgrid[ii][jj] < 2) {
                                    if (p.r > 0 && p.c > 0 && p.r < this.nrows && p.c < this.ncols) {
                                       if (this.maskgrid[p.r][p.c] > 1 && this.maskgrid[p.r][p.c] < regnum && this.maskgrid[p.r][p.c] % 2) {
                                          this.outside = false;
                                       }
                                    } else {
                                       this.outside = true;
                                    }
                                    this.maskgrid[ii][jj] = regnum;
                                    grown = true;
                                 }
                              }
                           });
                        } while (togrow.length);

                     }
                  }

               }
               regnum += outside ? 1 : 2;
            } while (grown)

            for (var i = 0; i < this.nrows; i++) {
               for (var j = 0; j < this.ncols; j++) {
                  this.maskgrid[i][j] = this.maskgrid[i][j] % 2;
               }
            }
            allpts.forEach((p) => {
               this.maskgrid[p.y][p.x] = 1;
               var bordered = false;
               var extent = 1;
               while (!bordered) {
                  bordered = true;
                  for (var i = -extent; i < extent + 1; i++) {
                     for (var j = -extent; j < extent + 1; j++) {
                        if (Math.abs(i) == extent || Math.abs(j) == extent) {
                           var cx = p.x + i;
                           var cy = p.y + j;
                           if (cx > 0 && cy > 0 && cx < this.ncols && cy < this.nrows) {
                              // console.log(extent);
                              //console.log(Math.hypot(cx * 2 * crad - p.rx, cy * 2 * crad - p.ry));
                              // console.log(crad + frame);
                              if (Math.hypot(cx * 2 * crad - p.rx, cy * 2 * crad - p.ry) < crad + frame) {
                                 this.maskgrid[cy][cx] = 1;
                                 bordered = false;
                              }
                           }
                        }

                     }
                  }
                  extent++;
               }
               // console.log("bordered");
            });
         }

         possibleconnections(mytiles, allowpartials) {
            var pcs = [];
            var neighbors = [[-1, -1], [-1, 1], [1, -1], [1, 1]];
            mytiles.forEach((v) => {
               if (v.hasconnections || allowpartials) {
                  v.hasconnections = false;
                  neighbors.forEach((n) => {
                     let cpt = new Tile(v.x + n[0], v.y + n[1]);
                     if (this.grid.istilevalid(cpt) && !this.maskgrid[cpt.y][cpt.x] && !mytiles.find(nv => nv.eq(cpt))) {
                        let dc = new DiagonalConnection(v, cpt, !this.grid.istilevisited(cpt));
                        if (this.grid.iscellempty(dc.cell)) {
                           if (allowpartials || !this.grid.istilevisited(cpt)) {
                              pcs.push(dc);
                              v.hasconnections = true;
                           }
                        }
                     }
                  });
               }
            });
            return pcs;
         }
         createpiece() {
            var mytiles = new Array();
            var myconnections = new Array();
            var targetpiecelen = Math.round(uniform(this.minpiecelen, this.maxpiecelen));
            var vi = this.grid.randomemptytile();
            mytiles.push(vi);
            this.grid.visittile(vi);


            while (this.grid.nunvisited > 0 && mytiles.length < targetpiecelen) {
               var possibleconnections = this.possibleconnections(mytiles, false);
               if (possibleconnections.length == 0) {
                  break;
               }
               var chosenconnection = possibleconnections[Math.floor(uniform(0, possibleconnections.length))];
               myconnections.push(chosenconnection);
               mytiles.push(chosenconnection.p2);
               this.grid.occupycell(chosenconnection.cell);
               this.grid.visittile(chosenconnection.p2);


            }

            if (mytiles.length >= this.minpiecelen) {
               this.pieces.push(myconnections);
            } else {
               myconnections.forEach((c) => {
                  this.grid.liberatecell(c.cell);
               })
            }
         }

         fillholes(allowpartials) {
            var filled = false;
            this.pieces = this.pieces.sort((a, b) => a.length - b.length);
            this.pieces.forEach((p) => {
               var tiles = [p[0].p1];
               p.forEach((con) => {
                  tiles.push(con.p2);
               });
               tiles.forEach((v) => {
                  var possibleconnections = this.possibleconnections([v], allowpartials);
                  if (possibleconnections.length) {
                     possibleconnections = possibleconnections.filter(function (ele) {
                        return !Boolean(tiles.find(vf => vf.eq(ele.p2)));
                     });
                     possibleconnections.forEach((pc) => {
                        p.push(pc);
                        tiles.push(pc.p2);
                        filled = true;
                        this.grid.occupycell(pc.cell);
                        this.grid.visittile(pc.p2);
                     });
                  }
               });

            });
            return filled;
         }


         static addarcs(con, connections, arcs, rad, frame, first) {
            var newarc;
            switch (con.quad) {
               case 0:
                  newarc = new Arc(new Tile(con.p1.x + 1, con.p1.y), rad, frame, 1, 1);
                  break;
               case 1:
                  newarc = new Arc(new Tile(con.p1.x, con.p1.y - 1), rad, frame, 2, 1);
                  break;
               case 2:
                  newarc = new Arc(new Tile(con.p1.x - 1, con.p1.y), rad, frame, 3, 1);
                  break;
               case 3:
                  newarc = new Arc(new Tile(con.p1.x, con.p1.y + 1), rad, frame, 0, 1);
                  break;
            }
            arcs.push(newarc);
            if (con.p2_taken) {
               var p2quads = [(con.quad + 3) % 4, (con.quad + 4) % 4, (con.quad + 5) % 4];
               p2quads.forEach((q) => {
                  var pct = DiagonalConnection.FromPointAndQuad(con.p2, q, true);
                  var pcnt = DiagonalConnection.FromPointAndQuad(con.p2, q, false);
                  if (connections.find(c => c.eq(pct))) {
                     CircleFractalJigsaw.addarcs(pct, connections, arcs, rad, frame, false);
                  } else if (connections.find(c => c.eq(pcnt))) {
                     CircleFractalJigsaw.addarcs(pcnt, connections, arcs, rad, frame, false);
                  } else {
                     arcs.push(new Arc(con.p2, rad, frame, q, 0));
                  }
               });
            } else {
               arcs.push(new Arc(con.p2, rad, frame, (con.quad + 2) % 4, 1));
            }

            switch (con.quad) {

               case 0:
                  newarc = new Arc(new Tile(con.p1.x, con.p1.y - 1), rad, frame, 3, 1);
                  break;
               case 1:
                  newarc = new Arc(new Tile(con.p1.x - 1, con.p1.y), rad, frame, 0, 1);
                  break;
               case 2:
                  newarc = new Arc(new Tile(con.p1.x, con.p1.y + 1), rad, frame, 1, 1);
                  break;
               case 3:
                  newarc = new Arc(new Tile(con.p1.x + 1, con.p1.y), rad, frame, 2, 1);
                  break;
            }
            arcs.push(newarc);

            if (first) {
               var p1quads = [(con.quad + 1) % 4, (con.quad + 2) % 4, (con.quad + 3) % 4];
               p1quads.forEach((q) => {
                  var pct = DiagonalConnection.FromPointAndQuad(con.p1, q, true);
                  var pcnt = DiagonalConnection.FromPointAndQuad(con.p1, q, false);
                  if (connections.find(c => c.eq(pct))) {
                     CircleFractalJigsaw.addarcs(pct, connections, arcs, rad, frame, false);
                  } else if (connections.find(c => c.eq(pcnt))) {
                     CircleFractalJigsaw.addarcs(pcnt, connections, arcs, rad, frame, false);
                  } else {
                     arcs.push(new Arc(con.p1, rad, frame, q, 0));
                  }
               });
            }

         }

         exportsvg(frame, crad, arcshape) {
            var width = this.ncols * 2 * crad + 2 * frame;
            var height = this.nrows * 2 * crad + 2 * frame;

            var data = "<?xml version=\"1.0\" encoding=\"utf-8\" ?><svg baseProfile=\"full\" height=\"" + height + "mm\" version=\"1.1\" viewBox=\"0 0 " + width + " " + height + "\" width=\"" + width + "mm\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:ev=\"http://www.w3.org/2001/xml-events\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs />"

            this.pieces.forEach((p) => {
               var arcs = [];
               CircleFractalJigsaw.addarcs(p[0], p, arcs, crad, frame, true);
               data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"M" + arcs[0].sp.x + "," + arcs[0].sp.y + " ";
               arcs.forEach((a) => {
                  data += a.svg(arcshape);
               });
               data += "Z\"></path>";
            });
            if (customborder.paths) {
               for (let p of customborder.paths) {
                  data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"";
                  data += p.getAttribute("d");
                  data += "\"></path>";
               }
            } else {
               data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"" + createframe() + "\"></path>";
            }
            data += "</svg>";
            return data;
         }
         exportsvg_nooverlap_singlepath(frame, crad, arcshape) {
            var width = this.ncols * 2 * crad + 2 * frame;
            var height = this.nrows * 2 * crad + 2 * frame;
            var data = "<?xml version=\"1.0\" encoding=\"utf-8\" ?><svg baseProfile=\"full\" height=\"" + height + "mm\" version=\"1.1\" viewBox=\"0 0 " + width + " " + height + "\" width=\"" + width + "mm\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:ev=\"http://www.w3.org/2001/xml-events\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs />"
            var allarcs = [];
            data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"";
            var currentlocation = new Tile(-1, -1);
            this.pieces.forEach((p) => {
               var arcs = [];
               CircleFractalJigsaw.addarcs(p[0], p, arcs, crad, frame, true);
               arcs.forEach((a) => {
                  if (!allarcs.find(na => na.eq(a))) {
                     allarcs.push(a);
                     if (!a.sp.eq(currentlocation)) {
                        data += "M" + a.sp.x + "," + a.sp.y + " "
                     }
                     data += a.svg(arcshape);
                     currentlocation = a.ep;
                  }
               });
            });
            data += "\"></path>"
            if (customborder.paths) {
               for (let p of customborder.paths) {
                  data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"";
                  data += p.getAttribute("d");
                  data += "\"></path>";
               }
            } else {
               data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"" + createframe() + "\"></path>";
            }
            data += "</svg>";
            return data;
         }

         exportsvg_nooverlap(frame, crad, arcshape) {
            var width = this.ncols * 2 * crad + 2 * frame;
            var height = this.nrows * 2 * crad + 2 * frame;
            var data = "<?xml version=\"1.0\" encoding=\"utf-8\" ?><svg baseProfile=\"full\" height=\"" + height + "mm\" version=\"1.1\" viewBox=\"0 0 " + width + " " + height + "\" width=\"" + width + "mm\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:ev=\"http://www.w3.org/2001/xml-events\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs />"
            var allarcs = [];
            var path = "";
            this.pieces.forEach((p) => {
               var inpath = false;
               var arcs = [];
               CircleFractalJigsaw.addarcs(p[0], p, arcs, crad, frame, true);
               arcs.forEach((a) => {
                  if (allarcs.find(na => na.eq(a))) {
                     if (inpath) {
                        path += "\"></path>"
                        data += path;
                        inpath = false;
                     }
                  } else {
                     allarcs.push(a);
                     if (!inpath) {
                        path = "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"M" + a.sp.x + "," + a.sp.y + " ";
                        inpath = true;
                     }
                     path += a.svg(arcshape);
                  }
               });
               if (inpath) {
                  path += "\"></path>"
                  data += path;
               }
            });
            if (customborder.paths) {
               for (let p of customborder.paths) {
                  data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"";
                  data += p.getAttribute("d");
                  data += "\"></path>";
               }
            } else {
               data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"" + createframe() + "\"></path>";
            }
            data += "</svg>";
            return data;
         }

         exportsvg_colored(border, crad, arcshape) {
            var width = this.ncols * 2 * crad + 2 * border;
            var height = this.nrows * 2 * crad + 2 * border;
            var data = "<?xml version=\"1.0\" encoding=\"utf-8\" ?><svg baseProfile=\"full\" height=\"" + height + "mm\" version=\"1.1\" viewBox=\"0 0 " + width + " " + height + "\" width=\"" + width + "mm\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:ev=\"http://www.w3.org/2001/xml-events\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs />"
            seed = coloring_seed;
            this.multipaths(frame, rad, arcshape).forEach((p) => {
               data += "<path fill=\"#" + Math.floor(uniform(0, 16777216)).toString(16) + "\" stroke=\"black\" stroke-width=\"" + rad / 20.0 + "\" d=\"";
               data += p
               data += "\"></path>"
            });
            if (customborder.paths) {
               for (let p of customborder.paths) {
                  data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"";
                  data += p.getAttribute("d");
                  data += "\"></path>";
               }
            } else {
               data += "<path fill=\"none\" stroke=\"black\" stroke-width=\"0.1\" d=\"" + createframe() + "\"></path>";
            }
            data += "</svg>";
            return data;
         }

         multipaths(frame, crad, arcshape) {
            var paths = [];
            var data = "";
            this.pieces.forEach((p) => {
               var data = ""
               var arcs = [];
               CircleFractalJigsaw.addarcs(p[0], p, arcs, crad, frame, true);
               data += "M" + arcs[0].sp.x + "," + arcs[0].sp.y + " ";
               arcs.forEach((a) => {
                  data += a.svg(arcshape);
               });
               data += "Z"
               paths.push(data);
            });
            return paths;
         }
         generate() {
            while (this.grid.nunvisited) {
               this.createpiece();
            }
            this.regenerategrid();
         }
         npieces() {
            return this.pieces.length;
         }
         regenerategrid() {
            this.grid.reset()

            for (var i = 0; i < this.nrows; i++) {
               for (var j = 0; j < this.ncols; j++) {
                  if (this.maskgrid[i][j]) {
                     this.grid.occupycell({ x: j, y: i });
                  }
               }
            }
            var np = 1;
            this.pieces.forEach((p) => {
               p.forEach((c) => {
                  if (!this.grid.istilevisited(c.p1)) {
                     this.grid.visittile(c.p1);
                  }
                  if (c.p2_taken) {
                     if (!this.grid.istilevisited(c.p2)) {
                        this.grid.visittile(c.p2);
                     }
                  }
                  this.grid.occupycell(c.cell);
               });
               np++;
            });
         }

      }

  // ======================= Fidget Critter wrapper =======================
  var IN = 25.4;
  var PRESETS = {
    // All puzzles are cut from 3 mm solid acrylic (fixed).
    material: { mm: 3, rad: 4.0, minTiles: 4, rim: 8 },
    sizes: { "3.5": 3.5, "10": 9.9, "9.9": 9.9, "11.5": 9.9 }  // "10" is the customer label; cut size is 9.9 in (251.46 mm)
  };

  // Layout (no randomness): grid size, frame width, mask for round shapes.
  function layout(o) {
    var t = PRESETS.material;
    var S = PRESETS.sizes[o.size] * IN;           // outer size in mm
    var rad = t.rad, d = 2 * rad;
    var n = Math.floor((S - 2 * t.rim) / d);       // square grid n x n
    var frame = (S - n * d) / 2;                   // rim so that outer == S exactly
    var mask = [], free = 0, cx = S / 2, R = S / 2;
    for (var i = 0; i < n; i++) {
      mask.push([]);
      for (var j = 0; j < n; j++) {
        var m = 0;
        if (o.shape === "round") {
          var x = j * d + rad + frame, y = i * d + rad + frame;
          if (Math.hypot(x - cx, y - cx) + rad > R - 0.7 * t.rim) m = 1;   // keeps a solid ring >= 0.7 x rim
        }
        mask[i].push(m); if (!m) free++;
      }
    }
    return { S: S, rad: rad, n: n, frame: frame, mask: mask, tiles: free, minTiles: t.minTiles, rim: t.rim };
  }

  // Sensible piece-count range for a layout.
  function pieceRange(L) {
    var min = Math.max(6, Math.round(L.tiles / 16));
    var max = Math.max(min + 4, Math.floor(L.tiles / (L.minTiles * 1.45)));
    return { min: min, max: max, def: Math.round((min + max) / 2) };
  }

  function build(L, o, minp, maxp) {
    seed = o.seed | 0;                                   // same seed -> same pattern
    var jig = new CircleFractalJigsaw(L.n, L.n, minp, maxp, {}, L.rad);
    if (o.shape === "round") {
      for (var i = 0; i < L.n; i++) for (var j = 0; j < L.n; j++)
        if (L.mask[i][j]) { jig.maskgrid[i][j] = 1; jig.grid.visittile({ x: j, y: i }); }
    }
    jig.generate();
    while (jig.fillholes(false));
    jig.fillholes(true);
    return jig;
  }

  // Deterministic search over piece-size limits so the real count lands near the slider target.
  function generate(o) {
    var L = layout(o);
    var R = pieceRange(L);
    var target = Math.min(R.max, Math.max(R.min, o.pieces | 0));
    var best = null, ks = [1.0, 0.85, 0.72, 0.62, 0.54, 0.47, 0.41, 1.15];
    for (var k = 0; k < ks.length; k++) {
      var avg = (L.tiles / target) * ks[k];
      var minp = Math.max(L.minTiles, Math.round(avg * 0.6));
      var maxp = Math.max(minp + 1, Math.round(avg * 1.45));
      if (best && best.minp === minp && best.maxp === maxp) continue;
      var jig = build(L, o, minp, maxp), n = jig.npieces();
      if (!best || Math.abs(n - target) < Math.abs(best.n - target)) best = { jig: jig, n: n, minp: minp, maxp: maxp };
      if (Math.abs(n - target) <= Math.max(1, target * 0.04)) break;
    }
    var arcshape = o.style === "blocky" ? 1 : 0;
    return {
      opts: o, layout: L, range: R, target: target, minp: best.minp, maxp: best.maxp,
      jig: best.jig, arcshape: arcshape, pieces: best.n,
      piecePaths: best.jig.multipaths(L.frame, L.rad, arcshape)
    };
  }

  function f(v) { return (Math.round(v * 1000) / 1000).toString(); }

  function outlinePath(L, shape) {
    var S = L.S;
    if (shape === "round") {
      var r = S / 2;
      return "M" + f(S / 2 - r) + "," + f(S / 2) + " A" + f(r) + "," + f(r) + " 0 1,0 " + f(S / 2 + r) + "," + f(S / 2) +
             " A" + f(r) + "," + f(r) + " 0 1,0 " + f(S / 2 - r) + "," + f(S / 2) + " Z";
    }
    var c = 6;
    return "M" + c + ",0 H" + f(S - c) + " A" + c + "," + c + " 0 0,1 " + f(S) + "," + c + " V" + f(S - c) +
           " A" + c + "," + c + " 0 0,1 " + f(S - c) + "," + f(S) + " H" + c + " A" + c + "," + c + " 0 0,1 0," + f(S - c) +
           " V" + c + " A" + c + "," + c + " 0 0,1 " + c + ",0 Z";
  }

  // Non-overlapping cut vectors (upstream exportsvg_nooverlap logic) - each shared edge cut once.
  function cutPaths(res) {
    var L = res.layout, jig = res.jig, out = [], allarcs = [];
    jig.pieces.forEach(function (p) {
      var arcs = [], path = null;
      CircleFractalJigsaw.addarcs(p[0], p, arcs, L.rad, L.frame, true);
      arcs.forEach(function (a) {
        if (allarcs.find(function (na) { return na.eq(a); })) {
          if (path) { out.push(path); path = null; }
        } else {
          allarcs.push(a);
          if (!path) path = "M" + a.sp.x + "," + a.sp.y + " ";
          path += a.svg(res.arcshape);
        }
      });
      if (path) out.push(path);
    });
    return out;
  }

  function code(o) {
    return "FC-" + o.size + (o.shape === "round" ? "R" : "S") + "-" + (o.style === "blocky" ? "B" : "C") +
           "-" + ("00" + (o.pieces | 0)).slice(-3) + "-" + (o.seed | 0);
  }
  function parseCode(s) {
    // Customer label is 10"; cut size is 9.9 in. Accept FC-10… plus legacy 9.9 / 11.5 and older 3 mm marker codes.
    var m = /^\s*FC-(3\.5|10|9\.9|11\.5)([RS])-3?([CB])-(\d{1,3})-(\d{1,6})\s*$/i.exec(s || "");
    if (!m) return null;
    var sz = m[1];
    if (sz === "9.9" || sz === "11.5") sz = "10";
    return { size: sz, shape: m[2].toUpperCase() === "R" ? "round" : "square", 
             style: m[3].toUpperCase() === "B" ? "blocky" : "curvy", pieces: +m[4], seed: +m[5] };
  }

  // Laser-ready cut file: stroke-only 0.1 mm hairlines, true mm units, outline included, no colour fills.
  function cutSVG(res) {
    var L = res.layout, o = res.opts, S = f(L.S), c = code(o);
    var s = '<?xml version="1.0" encoding="UTF-8"?>\n' +
      '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + S + 'mm" height="' + S + 'mm" viewBox="0 0 ' + S + " " + S + '">\n' +
      "<title>Fidget Critter fractal puzzle " + c + "</title>\n" +
      "<desc>Pattern " + c + "; " + PRESETS.sizes[o.size] + " in " + o.shape + "; " + PRESETS.material.mm + " mm acrylic; " + res.pieces +
      " pieces; tile radius " + L.rad + " mm. Cut layer only: 0.1 mm hairlines, no fills. Units: 1 user unit = 1 mm. " +
      "Generated with Fractalpuzzlejs (MIT, proceduraljigsaw).</desc>\n" +
      '<g id="cut" fill="none" stroke="#000000" stroke-width="0.1">\n';
    cutPaths(res).forEach(function (d) { s += '<path d="' + d.trim() + '"/>\n'; });
    s += '<path id="outline" d="' + outlinePath(L, o.shape) + '"/>\n</g>\n</svg>\n';
    return s;
  }

  // Simple deterministic colour RNG for preview shading (does not touch the pattern seed).
  function shadeRng(s) { var x = s >>> 0 || 1; return function () { x ^= x << 13; x >>>= 0; x ^= x >> 17; x ^= x << 5; x >>>= 0; return x / 4294967296; }; }

  return { PRESETS: PRESETS, layout: layout, pieceRange: pieceRange, generate: generate, cutSVG: cutSVG,
           cutPaths: cutPaths, outlinePath: outlinePath, code: code, parseCode: parseCode, shadeRng: shadeRng, fmt: f };
})();
if (typeof module !== "undefined") module.exports = FCFractal;

